export enum ContractRequestStatus {
    Open = 1,
    Pending = 2,
    Recalled = 3,
    Assigned = 4,
    Needs_Info = 5,
    Rejected = 6,
    Drafting = 7,
    Completed = 8,
    Cancelled = 9,
    Save = 10
}
